import React from 'react';
import { LOG_LIST_QUERY, LOG_LEVELS_QUERY } from '../../queries';
import LogComponent from './LogComponent';
import ListBrowser, { CollectionType, getListBrowserStore } from '@ts-private/list-browser';
import { useApolloFetching } from '@ts-private/list-browser-apollo-extensions';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ExportModalComponent from 'features/common/components/export/ExportModalComponent';
import useLogFilters from './useLogFilters';

export const logsStore = getListBrowserStore({
  name: 'logs-browser',
  filterDefinitions: [
    {
      name: 'correlationId',
      caption: 'Logs.CorrelationId',
      type: 'text'
    },
    {
      name: 'message',
      caption: 'Logs.Message',
      type: 'text'
    },
    {
      name: 'startDate',
      caption: 'Logs.StartDate',
      type: 'date'
    },
    {
      name: 'startTime',
      caption: 'Logs.StartTime',
      type: 'time'
    },
    {
      name: 'endDate',
      caption: 'Logs.EndDate',
      type: 'date'
    },
    {
      name: 'endTime',
      caption: 'Logs.EndTime',
      type: 'time'
    },
    {
      name: 'level',
      caption: 'Logs.Level',
      type: 'select',
      underlyingType: 'number'
    },
    {
      name: 'onlyWithCorrelationId',
      caption: 'Logs.IncludeMessagesWithCorrelationIds',
      type: 'boolean'
    },
    {
      name: 'showLogEvent',
      caption: 'Logs.IncludeLogEvent',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'Logs.StartDate',
      value: 'StartDate'
    }
  ],
  pager: {
    orderBy: 'StartDate',
    direction: 'asc'
  }
});

const logoFetchingOptions = {
  queryOptions: { query: LOG_LIST_QUERY, name: 'logs', fetchPolicy: 'network-only' },
  collectionsOptions: [
    {
      queryOptions: { query: LOG_LEVELS_QUERY },
      name: 'logLevels',
      identifier: 'level',
      collectionType: CollectionType.Filter,
      valueKey: 'id',
      labelKey: 'name'
    }
  ]
};

const LogListBrowser = () => {
  useApolloFetching(logsStore, logoFetchingOptions);

  useLogFilters();

  return (
    <Card icon={ListAltIcon}>
      <ListBrowser store={logsStore} ItemComponent={LogComponent} />
      <ExportModalComponent store={logsStore} options={logoFetchingOptions} />
    </Card>
  );
};

export default LogListBrowser;
